import { PropsWithChildren } from 'react';
import { twMerge } from 'tailwind-merge';

interface PageProps {
  className?: string;
}

export const PageContainer = ({
  children,
  className,
}: PropsWithChildren<PageProps>) => {
  return (
    <div
      className={twMerge(
        'flex w-full flex-1 flex-col gap-2 bg-white',
        className,
      )}
    >
      <span className="h-1 bg-header-border"></span>
      <div className="flex flex-1 justify-center overflow-auto">
        <div className="flex w-full max-w-screen-2xl flex-1 flex-col">
          {children}
        </div>
      </div>
    </div>
  );
};
